export enum BrandIconId {
  achieving = 'achieving',
  balance = 'balance',
  bell = 'bell',
  bitcoin = 'bitcoin',
  businessMan = 'business-man',
  businessWoman = 'business-woman',
  calculator = 'calculator',
  calendarDay = 'calendar-day',
  calendarMonth = 'calendar-month',
  capitolBuilding = 'capitol-building',
  checkmark = 'checkmark',
  clock = 'clock',
  coins = 'coins',
  collaboration = 'collaboration',
  commodities = 'commodities',
  community = 'community',
  conversation = 'conversation',
  creative = 'creative',
  credentialStar = 'credential-star',
  creditCard = 'credit-card',
  culture = 'culture',
  diversify = 'diversify',
  document = 'document',
  eDelivery1 = 'e-delivery-1',
  eDelivery2 = 'e-delivery-2',
  education = 'education',
  email = 'email',
  expenses = 'expenses',
  family = 'family',
  gears = 'gears',
  globalImpact = 'global-impact',
  handshake = 'handshake',
  health = 'health',
  home = 'home',
  idea = 'idea',
  key = 'key',
  laptop = 'laptop',
  lineChart = 'line-chart',
  location = 'location',
  man = 'man',
  meal = 'meal',
  microphone = 'microphone',
  mobileDevice = 'mobile-device',
  mobileDeviceTouch = 'mobile-device-touch',
  monitor = 'monitor',
  network = 'network',
  none = 'none',
  office = 'office',
  other = 'other',
  paperStack = 'paper-stack',
  paycheck = 'paycheck',
  peaceMind = 'peace-mind',
  person = 'person',
  phone = 'phone',
  plan = 'plan',
  pleasure = 'pleasure',
  prioritize = 'prioritize',
  protection = 'protection',
  retirement = 'retirement',
  review = 'review',
  rewards = 'rewards',
  savings = 'savings',
  search = 'search',
  security = 'security',
  sign = 'sign',
  smallBusiness = 'small-business',
  splitPieChart = 'split-pie-chart',
  sustainability = 'sustainability',
  target = 'target',
  tools = 'tools',
  transferringFunds = 'transferring-funds',
  transport = 'transport',
  travel = 'travel',
  trophy = 'trophy',
  video = 'video',
  wedding = 'wedding',
  wifi = 'wifi',
  woman = 'woman',
  work = 'work',
  xMark = 'x-mark',
  ampfLogo = 'ampf-logo',
  ampfCompass = 'ampf-compass',
  socialFacebook = 'social-facebook',
  socialFacebookWhite = 'social-facebook-white',
  socialInstagram = 'social-instagram',
  socialLinkedin = 'social-linkedin',
  socialLinkedinWhite = 'social-linkedin-white',
  socialYoutube = 'social-youtube',
  socialYoutubeAlmostBlack = 'social-youtube-almost-black',
  socialYoutubeWhite = 'social-youtube-white',
  socialX = 'social-x',
  socialXWhite = 'social-x-white',
}
